;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { ButtonIcon } from '@qogita/ui/v2/button-icon'
import { Icon } from '@qogita/ui/v2/icon'
import clsx from 'clsx'

export function InventoryPricingReportBanner({
  className,
}: {
  className?: string
}) {
  return (
    <section
      className={clsx(
        'flex flex-col gap-4 rounded-lg border border-gray-200 bg-gradient-to-r from-[#FFFBEB] to-[#F1F1FF] p-6 shadow-sm',
        className,
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-4">
          <Icon
            name="heroicons/outline/megaphone"
            // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
            className="text-high-emphasis size-6"
          />
          <h2 className="typography-body-base-semibold text-high-emphasis">
            NEW: Pricing reports for all your price lists
          </h2>
        </div>
        <p className="text-default">
          Download your pricing report to see target prices, market demand, and
          your biggest opportunities. Available on all price lists and updated
          hourly.
        </p>
      </div>
      <Anchor
        href="/inventory"
        variant="text"
        rumActionName="Download your pricing reports"
        className="self-start"
      >
        Download your pricing reports
        <ButtonIcon name="heroicons/solid/arrow-right" />
      </Anchor>
    </section>
  )
}
